/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const purchaseRemoteLookupSchema = z.any();

export const purchaseRemoteLookupIdSchema = z.string();

export const purchaseRemoteLookupItemSchema = z.object({
  indexed_name: z.string(),
  name: z.string(),
  is_blocklisted: z.boolean(),
  is_deleted: z.boolean(),
  status: z.enum(["active", "deleting", "deleted", "blocklisting", "blocklisted"]),
  internal_id: common.objectId,
});

export const purchaseRemoteLookupFiltersSchema = z.object({});

export const purchaseRemoteLookupValidators = {
  id: purchaseRemoteLookupIdSchema,
  item: purchaseRemoteLookupItemSchema,
  filters: purchaseRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: 844dfc396213143e9cf5375a8b4f4f5a */
